import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Layout,
  theme,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  Checkbox,
  Spin,
  Col,
  Radio,
} from "antd";

import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";

import { useNavigate, useLocation } from "react-router-dom";

//PROJECT IMPORTS
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TextArea from "antd/lib/input/TextArea";
import TopContent from "../../../components/layouts/TopContent";
import appStatic from "../../../config/appStatic";
import appLabel from "../../../config/appLabel";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import definedApi from "../../../services/definedApi";
import AvailableDebitTags from "./components/AvailableDebitTags";
import AvailableCreditTags from "./components/AvailableCreditTags";
import UpdateAvailableDebitTags from "./components/UpdateAvailableDebitTags";
import UpdateAvailableCreditTags from "./components/UpdateAvailableCreditTags";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const EditGLA0500 = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;

  const navigate = useNavigate();
  const { newGLItems, statusData } = appStatic;

  const dispatch = useDispatch();
  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [officeData, setOfficeData] = useState([]);
  const [creditAccountData, setCreditAccountData] = useState([]);
  const [debitAccountData, setDebitAccountData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isMultipleCreditAccount, setIsMultipleCreditAccount] = useState(false);
  const [isMultipleDebitAccount, setIsMultipleDebitAccount] = useState(false);
  const [debitTagData, setDebitTagData] = useState([]);
  const [creditTagData, setCreditTagData] = useState([]);
  const [allowedCreditTags, setAllowedCreditTags] = useState([]);
  const [allowedDebitTags, setAllowedDebitTags] = useState([]);

  useEffect(() => {
    // getTemplate();
    getDetailById(state);
  }, []);

  function onCancel() {
    navigate("/gla0500", { replace: false });
  }

  const getDetailById = (params) => {
    setIsLoading(true);

    const url = `${definedApi.GetAccountingRulesList}/${params.key}?template=true`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objDetail = res;

        let tempDebitTagData = [];
        let tempCreditTagData = [];
        let tempOffice = [];
        let tempAccountData = [];
        let tempUpdatedCreditTagData = [];
        let tempUpdatedDebitTagData = [];

        // SHOW THE SAVED DATA
        useForm.setFieldsValue({
          name: objDetail?.name ?? "",
          officeId: objDetail?.officeId ?? "",
          description: objDetail?.description ?? "",
          accountToDebit:
            objDetail?.debitAccounts?.length > 0
              ? objDetail.debitAccounts[0]?.id ?? ""
              : "",
          accountToCredit:
            objDetail?.creditAccounts?.length > 0
              ? objDetail.creditAccounts[0]?.id ?? ""
              : "",
        });

        setIsMultipleDebitAccount(
          objDetail?.debitTags?.length >= 1 ? true : false
        );
        setIsMultipleCreditAccount(
          objDetail?.creditTags?.length >= 1 ? true : false
        );

        // console.log(objDetail);

        objDetail?.allowedOffices?.forEach((element) => {
          tempOffice.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.allowedAccounts?.forEach((element) => {
          tempAccountData.push({
            value: element.id,
            label: `${element.glCode} (${element.name})`,
          });
        });
        objDetail?.allowedDebitTagOptions?.forEach((element) => {
          tempDebitTagData.push({
            id: element.id,
            name: element.name,
            available: true,
            assigned: false,
          });
        });
        objDetail?.allowedCreditTagOptions?.forEach((element) => {
          tempCreditTagData.push({
            id: element.id,
            name: element.name,
            available: true,
            assigned: false,
          });
        });

        objDetail?.debitTags?.forEach((element) => {
          tempUpdatedDebitTagData.push({
            id: element?.tag?.id,
            name: element?.tag?.name,
            available: false,
            assigned: true,
          });
        });
        objDetail?.creditTags?.forEach((element) => {
          tempUpdatedCreditTagData.push({
            id: element?.tag?.id,
            name: element?.tag?.name,
            available: false,
            assigned: true,
          });
        });

        setAllowedCreditTags(tempUpdatedCreditTagData);
        setAllowedDebitTags(tempUpdatedDebitTagData);
        setDebitTagData(tempDebitTagData);
        setCreditTagData(tempCreditTagData);
        setOfficeData(tempOffice);
        setDebitAccountData(tempAccountData);
        setCreditAccountData(tempAccountData);
        setIsLoading(false);
      }
    });
  };

  const onSubmit = (formValues) => {
    if (isMultipleDebitAccount && isMultipleCreditAccount === true) {
      formValues.creditTags = allowedCreditTags.map((tag) => tag.id);
      formValues.debitTags = allowedDebitTags.map((tag) => tag.id);
    } else if (isMultipleCreditAccount && isMultipleCreditAccount === false) {
      delete formValues.creditTags;
      delete formValues.debitTags;
    }

    // console.log(formValues);
    // return;

    const url = `${definedApi.AccountingRules}/${state.key}`;

    const body = {
      ...formValues,
      method: "PUT",
      session,
    };

    // console.log(body);return
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, appLabel.EditAccountingRuleMsg);
          navigate("/gla0500");
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/gla0500");
          setIsLoading(false);
        },
      }
    );
  };

  return (
    <MainLayout isEnableRightSidebar={false}>
      <TopContent
        pageTitle={appLabel.editAccountingRules}
        pageItems={appStatic.editAccountingRulesItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          title={
            <Title level={4} style={{ color: "#000" }}>
              {appLabel.generalInfo}
            </Title>
          }
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form layout="vertical" onFinish={onSubmit} form={useForm}>
            <Card
              style={{
                boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                borderRadius: 20,
              }}
            >
              <Card
                style={{
                  marginBottom: "2%",
                  boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                }}
              >
                <Row style={{ justifyContent: "space-between" }}>
                  <Form.Item
                    name="name"
                    label={<Text strong>{appLabel.accountingRuleName}</Text>}
                    rules={[
                      {
                        required: true,
                        message: "Required Field",
                      },
                    ]}
                  >
                    <Input placeholder="xxxxxxxx" style={{ width: "30vh" }} />
                  </Form.Item>

                  <Form.Item
                    name="officeId"
                    label={<Text strong>{appLabel.accountingRuleOffice}</Text>}
                    rules={[
                      {
                        required: true,
                        message: "Required Field",
                      },
                    ]}
                  >
                    <Select
                      style={{ width: "30vh" }}
                      placeholder="Please select office"
                      showSearch
                      options={officeData}
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(
                          input?.toLowerCase()
                        )
                      }
                    />
                  </Form.Item>

                  <div style={{ width: "15vh" }}></div>
                </Row>

                <Row>
                  <Form.Item
                    name="description"
                    label={
                      <Text strong>{appLabel.accountingRuleDescription}</Text>
                    }
                  >
                    <TextArea style={{ width: "45vh", height: "15vh" }} />
                  </Form.Item>
                </Row>

                <Row style={{ justifyContent: "space-between" }}>
                  <div span={12} style={{ justifyContent: "center" }}>
                    <Title level={4} strong>
                      Debit Account Details
                    </Title>

                    <Radio.Group
                      onChange={() =>
                        setIsMultipleDebitAccount(!isMultipleDebitAccount)
                      }
                      value={isMultipleDebitAccount}
                    >
                      <Radio value={false}>Fixed Account</Radio>
                      <Radio value={true}>List of Accounts</Radio>
                    </Radio.Group>

                    {isMultipleDebitAccount ? (
                      <div>
                        {/* <AvailableDebitTags
                          tagName={"Debit"}
                          debitTags={setAllowedDebitTags}
                          tags={debitTagData}
                          setTags={setDebitTagData}
                          updateDebitTags={allowedDebitTags}
                        /> */}
                        <UpdateAvailableDebitTags
                          tagName={"Debit"}
                          setAllowedDebitTags={setAllowedDebitTags}
                          tags={debitTagData}
                          setTags={setDebitTagData}
                          allowedDebitTags={allowedDebitTags}
                        />
                        <Form.Item>
                          <Checkbox>
                            <Text strong>Allow multiple debit entries</Text>
                          </Checkbox>
                        </Form.Item>
                      </div>
                    ) : (
                      <Form.Item
                        name="accountToDebit"
                        label={<Text strong>{appLabel.debitRuleType}</Text>}
                        style={{ marginTop: "2%" }}
                      >
                        <Select
                          placeholder="Please select debit account"
                          style={{ width: "30vh" }}
                          options={debitAccountData}
                          showSearch
                          filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                              input?.toLowerCase()
                            )
                          }
                        />
                      </Form.Item>
                    )}
                  </div>

                  <div span={12}>
                    <Title level={4} strong style={{ marginBottom: "2%" }}>
                      Credit Account Details
                    </Title>

                    <Radio.Group
                      onChange={() =>
                        setIsMultipleCreditAccount(!isMultipleCreditAccount)
                      }
                      value={isMultipleCreditAccount}
                    >
                      <Radio value={false}>Fixed Account</Radio>
                      <Radio value={true}>List of Accounts</Radio>
                    </Radio.Group>

                    {isMultipleCreditAccount ? (
                      <div>
                        {/* <AvailableCreditTags
                          tagName="Credit"
                          creditTags={setAllowedCreditTags}
                          tags={creditTagData}
                          setTags={setCreditTagData}
                          // updateCreditTags={updateCreditTags}
                        /> */}

                        <UpdateAvailableCreditTags
                          tagName={"Credit"}
                          setAllowedCreditTags={setAllowedCreditTags}
                          tags={creditTagData}
                          setTags={setCreditTagData}
                          allowedCreditTags={allowedCreditTags}
                        />
                        <Form.Item>
                          <Checkbox>
                            <Text strong>Allow multiple credit entries</Text>
                          </Checkbox>
                        </Form.Item>
                      </div>
                    ) : (
                      <Form.Item
                        name="accountToCredit"
                        label={<Text strong>{appLabel.creditRuleType}</Text>}
                        style={{ marginTop: "2%" }}
                      >
                        <Select
                          placeholder="Please select credit account"
                          style={{ width: "30vh" }}
                          options={creditAccountData}
                          showSearch
                          filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                              input?.toLowerCase()
                            )
                          }
                        />
                      </Form.Item>
                    )}
                  </div>
                  <div style={{ width: "15vh" }}></div>
                </Row>
              </Card>

              <Form.Item>
                <Row>
                  {BOM.HasPermission("UPDATE_ACCOUNTINGRULE") && (
                    <CustomButton
                      content="Submit"
                      style={{
                        width: "10%",
                        marginLeft: "auto",
                        boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      }}
                      htmlType="submit"
                      backgroundColor="#92428B"
                      colorText="white"
                      hoverBackground="#AD4EA7"
                    />
                  )}
                  <CustomButton
                    content="Cancel"
                    style={{
                      width: "10%",
                      marginLeft: "1%",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    backgroundColor="#fff"
                    colorText="black"
                    hoverBackground="#F5F5F5"
                    onClick={onCancel}
                  />
                </Row>
              </Form.Item>
            </Card>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EditGLA0500);
